export function download(links) {
    if (typeof links === "string" || Array.isArray(links)) {
        if (typeof links === "string") links = [links];
        
        const token = window.localStorage.getItem("sessionToken");
        
        links.forEach(link => {
            const url = new URL(link);
            url.searchParams.append('token', token);
            
            const a = document.createElement("a");
            a.href = url.toString();
            a.download = true; // Браузер сам определит имя файла
            document.body.appendChild(a);
            a.click();
            setTimeout(() => a.remove(), 500);
        });
    }
}